import React from 'react';

const DownloadTheDataButton = ({ handleDownload }) => (
  <button
    className="data-download btn btn--primary u--margin-top-20"
    onClick={handleDownload}
  >
    Download the Data
  </button>
);

export default DownloadTheDataButton;
